import { GlobalOutlined } from "@ant-design/icons";
import { Masonry } from "@mui/lab";
import { Button, Card, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomWidgets from "./CustomWidgets";
import {
    DashboardGrids,
    dashboardUrlList,
    qualityMatricsGrids,
    qualityMetricsUrlList,
} from "./constant";
import "./Home.css";
import DailyManagmentChart from "../DailyManagmentDashboard/Index";

const { TabPane } = Tabs;

function Home() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const navigate = useNavigate();
    const userRole = getUserRole();
    const {
        selectedDates,
        selectedHotels,
        selectedHotelType,
        homeActiveTab,
        updateHomeActiveTab,
    } = useContext(SettingContext);

    const [APIs, setAPIs] = useState(filterAPI());
    const [start_date, end_date] = selectedDates;
    const hotel_ids = selectedHotels;

    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        hotel_type: selectedHotelType,
    });

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    function filterAPI(hotelType = selectedHotelType) {
        let finalList = [];
        switch (hotelType) {
            case "kiosk":
                finalList = dashboardUrlList.filter(
                    (e) =>
                        e.url === "getDashboardKioskCounts" ||
                        e.url === "getDashboardReviewsCounts" ||
                        e.url === "getDashboardCommonCounts" ||
                        e.url === "getDashboardCallCounts" ||
                        e.url === "getDashboardNewCallCounts" ||
                        e.url === "getDashboardCashCounts" ||
                        e.url === "getDashboardShiftNotesCounts",
                    e.url === "getDashboardMissedcallsRateCounts",
                );
                break;
            case "operation":
                finalList = dashboardUrlList.filter(
                    (e) =>
                        e.url === "getDashboardHotelCounts" ||
                        e.url === "getDashboardCommonCounts" ||
                        e.url === "getDashboardDynaCounts",
                );
                break;
            default:
                finalList = dashboardUrlList;
                break;
        }
        return finalList;
    }

    useEffect(() => {
        const API = filterAPI();
        console.log(API);
        setAPIs(API);
    }, [selectedHotelType]);

    useEffect(() => {
        setFormData({
            ...formData,
            hotel_type: selectedHotelType,
            hotel_ids: [],
            all_selected: true,
        });
    }, [selectedHotelType]);

    function showMap() {
        navigate(`/map`);
    }

    async function downloadReport() {
        console.log("Download Reports");
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        let res;
        if (homeActiveTab == 1) {
            res = await HTTP("/dashboard/getAllDashboardDataReport", {
                ...tempFormData,
            });
        } else {
            res = await HTTP("/dashboard/getAllQualityTechMatrixCountReport", {
                ...tempFormData,
            });
        }

        downloadCSV(
            res,
            homeActiveTab == 1
                ? `dashboard_reports`
                : "quality_metrics_reports",
        );
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    <>
                        <GlobalOutlined
                            style={{
                                fontSize: "25px",
                                color: "#7794b3",
                                verticalAlign: "middle",
                                marginRight: "5px",
                            }}
                            onClick={showMap}
                        />
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downloadReport}
                        >
                            Download
                        </Button>
                    </>
                }
            />
            <Tabs
                type="card"
                destroyInhomeActiveTabPane
                onChange={(tab) => {
                    updateHomeActiveTab(`${tab}`);
                }}
                activeKey={homeActiveTab}
                defaultActiveKey={homeActiveTab}
            >
                <TabPane key="1" tab="Dashboard">
                    <Masonry columns={1} spacing={1}>
                        <div className="dashboard-count-card">
                            {APIs.map((e) => (
                                <CustomWidgets
                                    key={e.queryKey}
                                    grids={
                                        userRole === "Sales"
                                            ? DashboardGrids.filter(
                                                  (e) =>
                                                      e.key !==
                                                      "call_logs_count",
                                              )
                                            : DashboardGrids
                                    }
                                    configs={e}
                                />
                            ))}
                        </div>
                    </Masonry>
                </TabPane>
                <TabPane key="2" tab="Quality Tech Metrics">
                    <div className="dashboard-count-card">
                        {qualityMetricsUrlList.map((e) => {
                            return (
                                <>
                                    <CustomWidgets
                                        key={e.queryKey}
                                        grids={qualityMatricsGrids.filter(
                                            (e) => !e.parent,
                                        )}
                                        configs={e}
                                    />
                                </>
                            );
                        })}
                    </div>
                    <hr style={{ borderColor: "#80808057" }} />
                    <h4 style={{ marginLeft: "12px", color: "grey" }}>
                        PMS Softwares
                    </h4>
                    <div className="dashboard-count-card">
                        <CustomWidgets
                            grids={qualityMatricsGrids.filter(
                                (e) => e?.parent == "PMS Softwares",
                            )}
                            configs={{
                                queryKey: "qualityMetrixNew",
                                url: "getMoreSupportTicketErrorCounts",
                            }}
                        />
                    </div>
                    <hr style={{ borderColor: "#80808057" }} />
                    <h4 style={{ marginLeft: "12px", color: "grey" }}>
                        Key Softwares
                    </h4>
                    <div className="dashboard-count-card">
                        <CustomWidgets
                            grids={qualityMatricsGrids.filter(
                                (e) => e?.parent == "Key Softwares",
                            )}
                            configs={{
                                queryKey: "qualityMetrixNew",
                                url: "getMoreSupportTicketErrorCounts",
                            }}
                        />
                    </div>
                </TabPane>
                <TabPane key="3" tab="Aavgo Daily Management">
                    <DailyManagmentChart />
                </TabPane>
            </Tabs>
        </Card>
    );
}

export { DashboardGrids, Home };
